import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareFacebook } from '@fortawesome/free-brands-svg-icons/faSquareFacebook';
import { faSquareLinkedin } from '@fortawesome/free-brands-svg-icons/faSquareLinkedin';
import { faSquareXTwitter } from '@fortawesome/free-brands-svg-icons/faSquareXTwitter';
import classNames from 'classnames';

import styles from './socialMediaShareButtonsStyles.scss';

const sanitizeText = (text: string): string =>
  window.encodeURIComponent ? window.encodeURIComponent(text) : text;

interface SocialMediaShareButtonProps {
  shareText?: string;
  shareUrl: string;
  size?: 'sm' | 'md' | 'lg';
}

const LinkedInButton: FC<SocialMediaShareButtonProps> = ({ shareText, shareUrl, size = 'md' }) => {
  let href = `https://www.linkedin.com/shareArticle?mini=true&url=${shareUrl}`;
  if (shareText) href += `&text=${sanitizeText(shareText)}`;

  return (
    <a
      className={classNames(styles.socialMediaShareButton, styles[size], styles.linkedin)}
      href={href}
      target="_blank"
    >
      <FontAwesomeIcon icon={faSquareLinkedin} />
    </a>
  );
};

const FacebookButton: FC<Omit<SocialMediaShareButtonProps, 'shareText'>> = ({
  shareUrl,
  size = 'md'
}) => {
  return (
    <a
      className={classNames(styles.socialMediaShareButton, styles[size], styles.facebook)}
      href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
      target="_blank"
    >
      <FontAwesomeIcon icon={faSquareFacebook} />
    </a>
  );
};

const TwitterButton: FC<SocialMediaShareButtonProps> = ({ shareText, shareUrl, size = 'md' }) => {
  let href = `https://twitter.com/intent/tweet?url=${shareUrl}`;
  if (shareText) href += `&text=${sanitizeText(shareText)}`;
  return (
    <a
      className={classNames(styles.socialMediaShareButton, styles[size], styles.twitter)}
      href={href}
      target="_blank"
    >
      <FontAwesomeIcon icon={faSquareXTwitter} />
    </a>
  );
};

const SocialMediaShareButtons = {
  FacebookButton,
  LinkedInButton,
  TwitterButton
};

export default SocialMediaShareButtons;
